import React from 'react';
import styles from './StaticNotification.module.scss';

const StaticNotification = props => {
    const {className, icon, children} = props;

    return (
        <div className={[styles.StaticNotification, className, icon ? styles.hasIcon : ''].join(' ')}>
            {icon ? <span className={styles.icon}>{icon}</span> : null}
            {children}
        </div>
    );
};

export default StaticNotification;
